export default __webpack_public_path__ + "static/media/circleTick-default.e0e3bd75.png";